module.exports = __webpack_public_path__ + "img/2.fefdb2d7.jpg";